module.exports = __webpack_public_path__ + "static/media/Cats eyes 08_TYSKA-mixdown.41357aa8.mp3";